export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '车牌号',
                value: 'vehicleCard',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '分公司',
                value: 'companyNameList',
                type: 'advance',
                unfold: true,
                multiple: true,
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn',
                    value: '分公司名称'
                },
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '分公司名称' },
                    { prop: 'escoCompanyNo', value: '分公司编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '分公司名称' },
                    { prop: 'escoCompanyNo', value: '分公司编码' }
                ],
                advanceUrl: '/searchBrand',
                cbParams: [
                    'escoCompanyNameCn#companyNameList',
                    'escoCompanyNo#companyCode'
                ],
                span: 3
            },
            {
                name: '服务平台',
                value: 'siteNameList',
                type: 'advance',
                unfold: true,
                multiple: true,
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn',
                    value: '服务平台名称'
                },
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' }
                    // { prop: 'branchCompanyNo', value: '分公司编码' },
                    // { prop: 'branchCompanyName', value: '分公司名称' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: [
                    'escoCompanyNo#siteCode',
                    'escoCompanyNameCn#siteNameList'
                ],
                // advanceCascade: 'companyCode',
                span: 3
            },
            {
                name: '批次号',
                value: 'batchNum',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '承运商',
                value: 'carrierNameList',
                type: 'advance',
                unfold: true,
                advanceNotSearch: true,
                queryConditionRequired: true,
                multiple: true,
                multipleTableColumn: {
                    prop: 'supplierNameCn',
                    value: '承运商名称'
                },
                advanceConfig: [
                    { prop: 'supplierNameCn', value: '承运商名称' },
                    { prop: 'supplierCode', value: '承运商编码' }
                ],
                tableConfig: [
                    { prop: 'supplierNameCn', value: '承运商名称' },
                    { prop: 'supplierCode', value: '承运商编码' }
                ],
                method: 'post',
                prefix: '/api-tms',
                advanceUrl: '/srm/supplier/search',
                cbParams: [
                    'supplierNameCn#carrierNameList',
                    'supplierCode#carrierCode'
                ],
                span: 3
            },
            {
                name: '创建时间',
                value: 'createTime',
                type: 'time',
                unfold: true,
                span: 5,
                timeNum: 6,
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间'
            },
            {
                name: '导入类型',
                value: 'importType',
                type: 'select',
                optionNum: 'PILOT_VEHICLE_CONFIG_TYPE',
                options: [],
                unfold: true,
                span: 3
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        height: 400,
        leftWidth: 110,
        tableCut: false,
        clickModify: true,
        selectBtn: true,
        leftOperation: false,
        columns: [
            {
                label: '批次号',
                prop: 'batchNum',
                width: 200
            },
            {
                label: '车牌号',
                prop: 'vehicleCard',
                width: 120
            },
            {
                label: '承运商编码',
                prop: 'carrierCode',
                width: 150
            },
            {
                label: '承运商名称',
                prop: 'carrierName',
                width: 150
            },
            {
                label: '分公司编码',
                prop: 'companyCode',
                width: 150
            },
            {
                label: '分公司名称',
                prop: 'companyName',
                width: 150
            },
            {
                label: '服务平台编码',
                prop: 'siteCode',
                width: 150
            },
            {
                label: '服务平台名称',
                prop: 'siteName',
                width: 150
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: 200
            },
            {
                label: '启用创建时间',
                prop: 'createTime',
                width: 200
            },
            {
                label: '导入类型',
                prop: 'importType',
                width: 200,
                type: 'select',
                optionNum: 'PILOT_VEHICLE_CONFIG_TYPE',
                options: []
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 200]
    },
    searchTotalTitle: [
    ],
    ImportConfig: {
        action: `${process.env.VUE_APP_API_URL || ''}/api-tms/billingPilotVehicleSwitchConfig/importFile`,
        multiple: false,
        accept: '.xlsx,.xls',
        showFileList: true,
        fileType: '只能上传Excel文件，且不能超过500KB',
        manualUpload: false,
        fixSuccessfulMsg: true,
        errorDownloadContent: '点击下载异常表格数据',
        extraData: { importType: 0 }, // 0长合车计费变革试点导入
        errorTitle: ''
    },
    ImportContent: [
        {
            fileName: '长合车计费变革试点导入模版.xlsx',
            fileSize: '17.6KB',
            downLoadInfo: {
                url: ''
            }
        }
    ],
    algorithmicImportConfig: {
        action: `${process.env.VUE_APP_API_URL || ''}/api-tms/billingPilotVehicleSwitchConfig/importFile`,
        multiple: false,
        accept: '.xlsx,.xls',
        showFileList: true,
        fileType: '只能上传Excel文件，且不能超过500KB',
        manualUpload: false,
        fixSuccessfulMsg: true,
        errorDownloadContent: '点击下载异常表格数据',
        extraData: { importType: 1 }, // 1算法排车计费变革导入
        errorTitle: '算法排车计费变革导入框'
    },
    algorithmicImportContent: [
        {
            fileName: '算法排车计费变革导入模版.xlsx',
            fileSize: '17.6KB',
            downLoadInfo: {
                url: ''
            }
        }
    ]
};
